import { Component, HostBinding, signal } from '@angular/core';
import { TRANSLATION_PREFIX } from '@pipes/t.pipe';
import { AbbTabsComponent } from '@components/abb-tabs/abb-tabs.component';
import { TAB } from '@constants/constants';
import { URLS } from '@constants/urls';

@Component({
  selector: 'abb-automations',
  standalone: true,
  imports: [AbbTabsComponent],
  template: `
    <abb-tabs
      class="flex flex-col w-full flex-1 overflow-hidden gap-6"
      [tabs]="tabs"
    ></abb-tabs>
  `,
  styles: ``,
  providers: [
    {
      provide: TRANSLATION_PREFIX,
      useValue: 'controls.tabs.automations',
    },
  ],
})
export class AutomationsComponent {
  @HostBinding('attr.id') componentid = 'automations-component';
  tabs: Array<TAB> = [
    { link: URLS.CONFIGURED, label: 'Configured' },
    { link: URLS.LOGS, label: 'Logs' },
  ];

}
